<template>
  <div id="app">
    <v-app id="inspire">

      <Menu v-if="authenticated"/>
      
      <v-main>
        <v-container fluid style="padding-bottom:50px;">

          <router-view></router-view>

          <v-snackbar v-model="alert.active" :color="alert.tipe" :multi-line="true">
            {{ alert.text }}
            <v-btn text @click="alert.active = false">
              <v-icon>fal fa-times</v-icon>
            </v-btn>
          </v-snackbar>

          <v-footer absolute dark color="blue-grey darken-3">

            <Breadcumbs class="d-none d-sm-block"/>

            <div class="d-sm-none">{{ $route.meta.breadCrumb }}</div>

            <v-spacer></v-spacer>

            <v-btn icon color="white" @click="sheet = !sheet">
              <v-icon dark>fas fa-copyright</v-icon>
            </v-btn>

            <v-bottom-sheet v-model="sheet" dark>
              <v-sheet class="text-center" height="210px">
                <br>
                <p>
                  Copyright &copy; 2013 - {{ $date(Date()).format('YYYY') }}
                  <br>
                  Todos os direitos reservados a <a href="https://www.cetaba.org/">CETABA</a>
                </p>
                <v-divider></v-divider>
                <br>
                <p>Entre em contato</p>
                <p>
                  E-mail: tadeu_10@hotmail.com
                  <br>
                  Telefone: +55 45 99947-1274
                </p>
              </v-sheet>
            </v-bottom-sheet>

          </v-footer>
        </v-container>
      </v-main>


    </v-app>
  </div>
</template>

<script>
import Menu from './components/Menu.vue'
import Breadcumbs from './components/Breadcumbs'

import idb from '@/api/idb'

import { mapState } from 'vuex'

export default {
  components: {
    Menu,
    Breadcumbs
  },
  data() {
    return {
      sheet: false,
      alert: {
        active: false,
        text: null,
        tipe: null
      }
    }
  },
  computed: {
		...mapState([
			'authenticated',
			'user',
			'alertMessage',
			'alertType',
			'XMLHttpRequest',
		]),
	},
  watch:{
    
    alert: {
			deep: true,
			handler(alert) {
				if (alert.active == false) {
					this.GetAlert(undefined, undefined)
				}
			},
		},
		alertMessage(message) {
			if (message !== undefined) {
				this.ShowAlert()
			}
		},
		XMLHttpRequest(value) {
			this.messageXMLHttpRequest(value)
		},
  },

  created() {
		this.StartiDB()
		this.checkInternet()
	},

  methods:{
    checkInternet() {
			let temp = window.navigator.onLine
			this.$store.dispatch('XMLHttpRequest', { value: temp })
			// this.messageXMLHttpRequest(temp)
		},

		messageXMLHttpRequest(value) {
			let message = value === true ? 'Com internet' : 'Sem internet'
			let type = value === true ? 0 : 2
			this.$store.dispatch('alert', {
				alertMessage: message,
				alertType: type,
			})
		},

		StartiDB() {
			idb.createDB()
		},
		GetAlert(alertMessage, alertType) {
			this.$store.dispatch('alert', {
				alertMessage: alertMessage,
				alertType: alertType,
			})
		},
		ShowAlert() {
			this.alert.text = this.alertMessage
			let tipe
			if (this.alertType == 0) {
				tipe = 'success'
			} else if (this.alertType == 1) {
				tipe = 'warning'
			} else {
				tipe = 'error'
			}
			this.alert.tipe = tipe
			this.alert.active = true
		},
    // for (var index in this.dados) {
    //   console.log("Index: "+index+"\nValor: "+this.dados[index].id)
    // }
  }
}
</script>

<style lang="css">
@media (max-width: 767px) {
	.hide-mobile {
		display: none;
	}
}
.nl2br {
	white-space: pre-wrap;
	line-height: 1 !important;
}

.v-breadcrumbs{ padding: 0px 12px;}
/* Quebra de linha */
table *, v-list *{
  white-space: pre-wrap !important;
}
.v-list-item__title, .v-list-item__subtitle {
  white-space: pre-wrap !important;
  padding: 5px 0;
}
</style>

<style lang="scss">
// Font Awesome5 Pro
$fa-font-path: "./assets/font/webfonts";
@import "./assets/font/scss/fontawesome";
@import "./assets/font/scss/solid"; // fas
@import "./assets/font/scss/regular"; // far
@import "./assets/font/scss/light"; // far
@import "./assets/font/scss/brands"; // fab
@import "./assets/font/scss/v4-shims"; // fab
</style>